import PreviewNavPoolsItem from "pages/PreviewPage/PreviewNavPoolsItem/PreviewNavPoolsItem";

export default PreviewNavPoolsItem;
